import type { UrgentLevel } from '@/shared/components/cse'
import { useUrgentMessages } from '@/shared/api/urgentMessagesQueries'

export interface UrgentBannerMessage {
  /** Identifiant stable (clé de fermeture localStorage). */
  id: string
  level: UrgentLevel
  title?: string
  message: string
  dismissible: boolean
}

/**
 * Bandeaux de communication urgente - source serveur (RV-31, endpoint
 * `GET /urgent-messages`, géré côté admin Filament). Le point de montage existe
 * dans `AppLayout`. Retourne `[]` tant que la requête n'a pas de données (chargement,
 * non-authentifié, ou aucun message actif).
 */
export function useUrgentBanners(): UrgentBannerMessage[] {
  const query = useUrgentMessages()

  return (query.data ?? []).map((m) => ({
    id: m.id,
    level: m.level,
    title: m.title ?? undefined,
    message: m.message,
    dismissible: m.dismissible,
  }))
}
